
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/32-percent-growth-in-staar-scores-in-texas",
      function () {
        return require("private-next-pages/c/blog-posts/32-percent-growth-in-staar-scores-in-texas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/32-percent-growth-in-staar-scores-in-texas"])
      });
    }
  